namespace TabAurous.OMS {
    export interface DenominationRow {
        DenominationId?: number;
        Code?: number;
        Name?: string;
    }

    export namespace DenominationRow {
        export const idProperty = 'DenominationId';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'OMS.Denomination';
        export const deletePermission = 'Customer:Delete';
        export const insertPermission = 'Customer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Customer:Edit';

        export declare const enum Fields {
            DenominationId = "DenominationId",
            Code = "Code",
            Name = "Name"
        }
    }
}
